import { lazy, Suspense, type ReactNode } from 'react'
import { Card, Empty, Skeleton } from 'antd'
import type { EChartsCoreOption } from 'echarts/core'

const EChartsView = lazy(() => import('./echarts-view.tsx'))
export function ChartPanel({
  title,
  description,
  option,
  loading = false,
  empty = false,
  extra,
  children
}: {
  title: string
  description: string
  option: EChartsCoreOption
  loading?: boolean
  empty?: boolean
  extra?: ReactNode
  children?: ReactNode
}) {
  return (
    <Card
      loading={loading}
      title={
        <div className="flex flex-wrap items-center justify-between gap-3 py-3">
          <h2 className="m-0 min-w-0 text-base font-semibold whitespace-normal">{title}</h2>
          {extra}
        </div>
      }
      className="h-full min-w-0 rounded-2xl!"
      classNames={{ header: 'px-5 sm:px-6', body: 'p-5 sm:p-6' }}
    >
      <p className="text-content-muted mt-0 mb-4 text-xs leading-relaxed">{description}</p>
      {children}
      {empty ? (
        <div className="flex h-72 items-center justify-center">
          <Empty description="所选范围暂无数据" />
        </div>
      ) : (
        <Suspense
          fallback={
            <div className="h-72">
              <Skeleton active />
            </div>
          }
        >
          <EChartsView label={`${title}。${description}`} option={option} />
        </Suspense>
      )}
    </Card>
  )
}
